__turbopack_context__.v({
  "buttonBox": "styles-module-scss-module__IVjLdW__buttonBox",
  "icon": "styles-module-scss-module__IVjLdW__icon",
  "loading": "styles-module-scss-module__IVjLdW__loading",
  "root": "styles-module-scss-module__IVjLdW__root",
  "text": "styles-module-scss-module__IVjLdW__text",
});
